import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const loadMe = async () => {
    const t = localStorage.getItem("vp_token");
    if (!t) { setUser(null); setReady(true); return null; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      setReady(true);
      return r.data;
    } catch (err) {
      // Solo borramos el token si el backend nos dice explícitamente que la
      // sesión no es válida (401/403). En errores transitorios (timeout 504,
      // backend bloqueado parseando un PDF, red caída, etc.) mantenemos el
      // token: la sesión sigue siendo válida y el usuario no debe ser
      // expulsado.
      const code = err?.response?.status;
      if (code === 401 || code === 403) {
        localStorage.removeItem("vp_token");
        setUser(null);
      }
      setReady(true);
      return null;
    }
  };

  useEffect(() => { loadMe(); }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("vp_token", r.data.token);
    // Inyectamos el flag must_change_password desde la respuesta de login para
    // que ProtectedRoute pueda redirigir inmediatamente sin esperar a /auth/me.
    const u = { ...r.data.user, must_change_password: !!r.data.must_change_password };
    setUser(u);
    return u;
  };
  const logout = () => {
    localStorage.removeItem("vp_token");
    setUser(null);
  };
  const token = () => localStorage.getItem("vp_token");
  const refresh = () => loadMe();
  const setSession = (tok, u) => {
    localStorage.setItem("vp_token", tok);
    setUser(u);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, token, refresh, setSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const c = useContext(AuthCtx);
  if (!c) throw new Error("useAuth fuera del provider");
  return c;
}
